module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



//////////////////
// WEBPACK FOOTER
// ./~/hash-base/~/readable-stream/lib/internal/streams/from-browser.js
// module id = 493
// module chunks = 1474